<template>
  <div>
    <div class="d-flex align-items-center">
      <div class="side-frame-danger"></div>
      <div style="font-size: 14px; color: #606266">
        <span> {{ $l('group_shippingmark') || '唛头信息' }}</span>
        <el-divider direction="vertical" v-if="!disabled"></el-divider>
        <b-button
          class="mr-2"
          size="sm"
          variant="outline-success"
          @click="visible = true"
          v-if="!disabled"
        >
          {{ $l('btn_choose_shippingmark') || '选择唛头' }}
        </b-button>
      </div>
    </div>
    <div class="shippingMark" v-if="shippingMarkType">
      <span class="shippingMark_text">
        {{ shippingMarkText }}
      </span>
      <span class="shippingMark_image">
        <el-image
          style="width: 80px; height: 80px"
          fit="contain"
          :src="
            shippingMarkImageUrl
              ? shippingMarkImageUrl
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            shippingMarkImageUrl
              ? shippingMarkImageUrl
              : '/image/static/img/nopic.jpg',
          ]"
        >
        </el-image>
      </span>
    </div>
    <ChooseShippingMark
      :visible.sync="visible"
      :title="$l('dialog_title_select_shippingmark') || '请选择唛头'"
      :custCode="custCode"
      :destinationPort="destinationPort"
      @confirm="onChooseConfirm"
    />
  </div>
</template>

<script>
import ChooseShippingMark from '../choose-shipping-mark'
export default {
  components: { ChooseShippingMark },
  props: {
    disabled: { type: Boolean, default: false },
    size: { type: String, default: 'small' },
    shippingMarkType: { type: String, default: '' },
    shippingMarkText: { type: String, default: '' },
    shippingMarkImageUrl: { type: String, default: '' },
    shippingMarkImageFileCode: { type: String, default: '' },
    custCode: { type: String, default: '' },
    destinationPort: { type: String, default: '' },
  },
  watch: {
    destinationPort: {
      handler(e) {
        if (!this.shippingMarkDestinationPort || !e) return
        if (e !== this.shippingMarkDestinationPort) {
          this.changeValue()
        }
      },
    },
  },
  data() {
    return {
      visible: false,
      shippingMarkDestinationPort: '',
    }
  },
  methods: {
    onChooseConfirm(e) {
      if (!e) return
      const { destinationPort } = e
      this.shippingMarkDestinationPort = destinationPort
      this.changeValue(e)
    },
    changeValue(e = {}) {
      const {
        shippingMarkType,
        shippingMarkText,
        shippingMarkImageUrl,
        shippingMarkImageFileCode,
        shippingMarkCode,
      } = e
      this.$emit('update:shippingMarkType', shippingMarkType)
      this.$emit('update:shippingMarkText', shippingMarkText)
      this.$emit('update:shippingMarkImageUrl', shippingMarkImageUrl)
      this.$emit('update:shippingMarkImageFileCode', shippingMarkImageFileCode)
      this.$emit('update:shippingMarkCode', shippingMarkCode)
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-danger {
  padding: 1px 5px;
  border-left: 3px solid $color-danger;
  height: 20px;
}

.shippingMark {
  display: flex;
  align-items: center;
  padding: 0 10px;
  .shippingMark_text {
    margin-right: 10px;
    font-size: 30px;
  }
}
</style>
